import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { PageMetadataProvider } from '../context/PageMetadataContext';
import './App.css';
import Header from './Header';
import Footer from './Footer';
import HomePage from '../pages/HomePage';
import BioPage from '../pages/BioPage';
import ResearchPage from '../pages/ResearchPage';
import ProjectsPage from '../pages/ProjectsPage';
import PublicationsPage from '../pages/PublicationsPage';
import TeachingPage from '../pages/TeachingPage';
import EventsPage from '../pages/EventsPage';
import SportPage from '../pages/SportPage';
import StaticFallback from './StaticFallback';

const App = () => {
  return (
    <PageMetadataProvider>
      <Router>
        <div className="app">
          {/* Skip to content link for accessibility */}
          <a href="#main-content" className="skip-link">
            Skip to main content
          </a>
          <Header />
          <main id="main-content" className="main">
            <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/bio" element={<BioPage />} />
        <Route path="/research" element={<ResearchPage />} />
        <Route path="/research.html" element={<Navigate to="/research" replace />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/projects.html" element={<Navigate to="/projects" replace />} />
        <Route path="/publications" element={<PublicationsPage />} />
        <Route path="/pubs.html" element={<Navigate to="/publications" replace />} />
        <Route path="/pubs" element={<Navigate to="/publications" replace />} />
        <Route path="/teaching" element={<TeachingPage />} />
        <Route path="/teaching.html" element={<Navigate to="/teaching" replace />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/events.html" element={<Navigate to="/events" replace />} />
        <Route path="/bio/sport" element={<SportPage />} />
        <Route path="/bio/sport.html" element={<Navigate to="/bio/sport" replace />} />
        {/* Catch-all route: fallback to static HTML files for unmatched routes */}
            <Route path="*" element={<StaticFallback />} />
          </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </PageMetadataProvider>
  );
};

export default App;

